import { data } from "./growing.data";

export {
    data
}